/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADMIN SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  togglebutton: {
    width: '200px',
    background: '#F5F5F5',
    borderRadius: '4px',
    justifyContent: 'center',
    alignItems: 'center',
    height: '44px',
    '& > div': {
      height: '32px', 
      width: '90px', 
      padding: '8px', 
      textAlign: 'center', 
      borderRadius: '4px',
      cursor: 'pointer',
      transition: 'ease-in background 0.10s',
      '&.active-true': {
        background: '#FFF',
        fontWeight: 700
      }
    }
  }
});
